import React, { useState, useEffect } from 'react';
import { Button, Grid, Modal, TextField, List, ListItem, ListItemText, Typography, Tabs, Tab, FormControl, InputLabel, Select, MenuItem, IconButton, useMediaQuery, Box } from '@mui/material';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Pagination from './Pagination';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';



const DetailsForm = ({ task, subtask, subtaskMainTaskTeamId, open, onClose, teams, projectId, currentUserRoleId, detailsTab,refreshData }) => {
    const [details, setDetails] = useState(null);
    const [newComment, setNewComment] = useState('');
    const [comments, setComments] = useState([]);
    const [fileLinks, setFileLinks] = useState([]);
    const [newFileLink, setNewFileLink] = useState('');
    const [newFileDescription, setNewFileDescription] = useState('');
    const [currentTab, setCurrentTab] = useState(detailsTab || 'details');
    const [newReply, setNewReply] = useState('');
    const [replyToCommentId, setReplyToCommentId] = useState(null); // Cevaplanan yorumun ID'si
    const [dependencies, setDependencies] = useState([]);
    const [dependentOn, setDependentOn] = useState([]);
    const [selectedTask, setSelectedTask] = useState('');
    const [dependencyType, setDependencyType] = useState('');
    const [availableItems, setAvailableItems] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);

    const [currentPage, setCurrentPage] = useState(1); // Mevcut sayfa numarası
    const itemsPerPage = 5; // Sayfa başına gösterilecek yorum sayısı
    const [totalComments, setTotalComments] = useState(0); // Toplam yorum sayısı

    // Bu kullanıcının verisi, initial olarak boş olmalı
    const [currentUserId, setCurrentUserId] = useState(null);
    const [currentUser, setCurrentUser] = useState({ teams: [], roleId: null });
    const user = JSON.parse(localStorage.getItem('user')) || {}; // Eğer `user` boşsa varsayılan değer veriyoruz
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [hasFullAccess, setHasFullAccess] = useState(false);

    const [assignedTeam, setAssignedTeam] = useState(null);
    const [assignedUser, setAssignedUser] = useState(null);
    const [members, setMembers] = useState([]);
    const [filteredMembers, setFilteredMembers] = useState([]);
    const [warningMessage, setWarningMessage] = useState('');
    const { t } = useTranslation();
    const { i18n } = useTranslation();

const isArabic = t.language === 'ar';
    const api = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_URL,
    });

    //setCurrentUserId(user.id);
    useEffect(() => {
        setCurrentUserId(user.id); // Kullanıcı ID'si burada set ediliyor
    }, [user]);


    const tabMapping = {
        details: 0,
        comments: 1,
        files: 2,
    };
    // `detailsTab` değiştiğinde sekmeyi güncelle
    useEffect(() => {
        //console.log("detailsTab değiştiğinde: ", detailsTab);
        if (detailsTab && tabMapping.hasOwnProperty(detailsTab)) {
            setCurrentTab(tabMapping[detailsTab]); // `detailsTab`'ı uygun `currentTab` numarasına çevir
        }
    }, [detailsTab]);




    // useEffect kancası - task veya subtask veya currentPage değiştiğinde detayları getir
    useEffect(() => {
        if (!task && !subtask) return;

        const itemType = task ? 'task' : 'subtask';
        const itemId = task ? task.id : subtask.id;

        const fetchDetails = async () => {
            try {
                const response = await api.get(`/api/comments/${itemType}/${itemId}/details?page=${currentPage}&limit=${itemsPerPage}`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                });

                const itemDetails = response.data[itemType];
                let earliestStart = null;
                let latestEnd = null;
                let parentTaskStart = null;
                let parentTaskEnd = null;

                if (itemType === 'task') {
                    // Eğer `task` türündeysek subtasks tarihlerini işleyelim
                    const subtasks = itemDetails.subtasks || [];
                    earliestStart = subtasks.length > 0
                        ? subtasks.map(sub => new Date(sub.start_date)).reduce((min, date) => (date < min ? date : min), new Date())
                        : null;
                    latestEnd = subtasks.length > 0
                        ? subtasks.map(sub => new Date(sub.due_date)).reduce((max, date) => (date > max ? date : max), new Date(0))
                        : null;
                } else if (itemType === 'subtask') {
                    // Eğer `subtask` türündeysek, ana task tarihlerini alalım
                    const parentTask = itemDetails.ParentTask || {};
                    parentTaskStart = parentTask.start_date ? new Date(parentTask.start_date) : null;
                    parentTaskEnd = parentTask.due_date ? new Date(parentTask.due_date) : null;
                }

                // Tarihleri "YYYY-MM-DD" formatına çevirin
                setDetails({
                    ...itemDetails,
                    start_date: new Date(itemDetails.start_date).toISOString().split('T')[0],
                    due_date: new Date(itemDetails.due_date).toISOString().split('T')[0],
                    earliest_subtask_start: earliestStart ? earliestStart.toISOString().split('T')[0] : null,
                    latest_subtask_end: latestEnd ? latestEnd.toISOString().split('T')[0] : null,
                    parent_task_start: parentTaskStart ? parentTaskStart.toISOString().split('T')[0] : null,
                    parent_task_end: parentTaskEnd ? parentTaskEnd.toISOString().split('T')[0] : null,





                });
                console.log(itemDetails);

                // Eğer `subtaskMainTaskTeamId` doluysa onu kullan, aksi takdirde `itemDetails` üzerinden al
                setAssignedTeam(subtaskMainTaskTeamId || itemDetails.assigned_team_id || null);
                setAssignedUser(itemDetails.assigned_user_id || itemDetails.assigned_to || null);
                setComments(Array.isArray(response.data.comments) ? response.data.comments : []);
                setTotalComments(response.data.totalComments || 0);

                const fileResponse = await api.get(`/api/filelinks/${itemType}/${itemId}/list`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                });
                setFileLinks(fileResponse.data);
                await fetchMembersWithTeams();
                await fetchDependencies(itemType, itemId);
                await fetchAvailableItems(itemType, itemId);
                await fetchProjectMemberDetails();
            } catch (error) {
            }
        };

        fetchDetails(); // Task detaylarını getir
    }, [open, isEditMode, task, subtask, currentPage, itemsPerPage, subtaskMainTaskTeamId]);


    // Proje üyesi bilgilerini almak için fonksiyon
    const fetchProjectMemberDetails = async () => {
        try {
            const token = localStorage.getItem('token');

            //console.log(user.id);
            const response = await api.get(`/api/projects/${projectId}/members/${user.id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            const memberData = response.data;
            //console.log("Member Data: ", memberData);
            setCurrentUser({
                ...currentUser,
                teams: memberData.teams || [],  // Takımlar
                roleId: memberData.roleId // Rol ID'si
            });

            //console.log('Current User after fetch:', currentUser);
        } catch (error) {
        }
    };

    const fetchMembersWithTeams = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await api.get(`/api/projects/${projectId}/members-with-teams`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setMembers(response.data);
            setFilteredMembers(response.data);
        } catch (error) {
        }
    };

    // Takım seçildiğinde üyeleri filtreleme
    useEffect(() => {
        if (assignedTeam) {
            const teamMembers = members.filter((member) =>
                Array.isArray(member.teams) && // `teams` bir dizi mi kontrol et
                member.teams.some((team) => team.id === assignedTeam)
            );
            setFilteredMembers(teamMembers);
    
            // Eğer daha önce seçilen kullanıcı yeni takımda değilse uyarı göster
            if (
                assignedUser &&
                !teamMembers.some((member) => member.id === assignedUser)
            ) {
                setWarningMessage(t('warning_user_not_in_team'));
                setAssignedUser(''); // Kullanıcıyı sıfırla
            } else {
                setWarningMessage(''); // Uyarıyı temizle
            }
        } else {
            setFilteredMembers(members); // Tüm üyeleri göster
            setWarningMessage('');
        }
    }, [assignedTeam, assignedUser, members]);
    



    const handleAddComment = async () => {
        try {
            const itemType = task ? 'task' : 'subtask';
            const itemId = task ? task.id : subtask.id;

            // Yorum ekleme
            await api.post(`/api/comments/${itemType}/${itemId}`, { content: newComment }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });


            setNewComment('');
            const response = await api.get(`/api/comments/${itemType}/${itemId}/details`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });
            setComments(response.data.comments);
        } catch (error) {
        }
    };

    const handleAddReply = async (commentId) => {
        try {
            const itemType = task ? 'task' : 'subtask';
            const itemId = task ? task.id : subtask.id;

            await api.post(`/api/comments/${itemType}/${itemId}`, { content: newReply, parentId: commentId }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });

            setNewReply('');
            const response = await api.get(`api/comments/${itemType}/${itemId}/details`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });
            setComments(response.data.comments);
        } catch (error) {
        }
    };



    const handleAddFileLink = async () => {
        try {
            const itemType = task ? 'task' : 'subtask';
            const itemId = task ? task.id : subtask.id;

            await api.post(`/api/filelinks/${itemType}/${itemId}`, { fileLink: newFileLink, description: newFileDescription }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });
            setNewFileLink('');
            setNewFileDescription('');
            const fileResponse = await api.get(`/api/filelinks/${itemType}/${itemId}/list`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });
            setFileLinks(fileResponse.data);
        } catch (error) {
        }
    };


    const fetchDependencies = async (itemType, itemId) => {
        try {
            const response = await api.get(`/api/${itemType}dependencies/detailed/${itemId}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });


            const { dependencies, dependentOn } = response.data;

            setDependencies(dependencies);
            setDependentOn(dependentOn);

            //console.log("Task Dependencies: ", dependencies);
            //console.log("Dependent On: ", dependentOn);
        } catch (error) {
        }
    };

    const checkStatusCompatibility = (newStatus) => {
        let isCompatible = true;

        // `dependentOn` listesi kontrolü
        dependentOn.forEach(dep => {

            if (dep.dependencyType === 'Finish-to-Start') {
                // Ana task "completed" değilse ve bu task "in-progress" yapılmak isteniyorsa
                if (dep.mainTask.status !== 'completed' && newStatus === 'in-progress') {
                    
                    toast.error(t('error_in_progress_requires_completion', { taskTitle: dep.mainTask.title }));
                    isCompatible = false;
                }
            }

            if (dep.dependencyType === 'Start-to-Start') {
                // Ana task "to-do" durumundaysa ve bu task "in-progress" yapılmak isteniyorsa
                if (dep.mainTask.status === 'to-do' && newStatus === 'in-progress') {
                    toast.error(t('error_in_progress_requires_start', { taskTitle: dep.mainTask.title }));
                    isCompatible = false;
                }
            }

            if (dep.dependencyType === 'Finish-to-Finish') {
                // Ana task "completed" değilse ve bu task "completed" yapılmak isteniyorsa
                if (dep.mainTask.status !== 'completed' && newStatus === 'completed') {
                    toast.error(t('error_completed_requires_completion', { taskTitle: dep.mainTask.title }));
                    isCompatible = false;
                }
            }

            if (dep.dependencyType === 'Start-to-Finish') {
                // Ana task "to-do" durumundaysa ve bu task "completed" yapılmak isteniyorsa
                if (dep.mainTask.status === 'to-do' && newStatus === 'completed') {
                    toast.error(t('error_completed_requires_start', { taskTitle: dep.mainTask.title }));
                    isCompatible = false;
                }
            }
        });


        // `dependencies` listesi kontrolü
        dependencies.forEach(dep => {

            if (dep.dependencyType === 'Finish-to-Start') {
                // Dependent task "in-progress" durumundaysa ve ana task "completed" yapılmak istenmiyorsa
                if (dep.dependentTask.status === 'in-progress' && newStatus !== 'completed') {
                    toast.error(t('error_status_dependency_started', { taskTitle: dep.dependentTask.title }));
                    isCompatible = false;
                }
            }

            if (dep.dependencyType === 'Start-to-Start') {
                // Dependent task "in-progress" durumundaysa ve ana task "to-do" yapılmak isteniyorsa
                if (dep.dependentTask.status === 'in-progress' && newStatus === 'to-do') {
                    toast.error(t('error_status_dependency_in_progress', { taskTitle: dep.dependentTask.title }));
                    isCompatible = false;
                }
            }

            if (dep.dependencyType === 'Finish-to-Finish') {
                // Dependent task "completed" durumundaysa ve ana task "to-do" veya "in-progress" yapılmak isteniyorsa
                if (dep.dependentTask.status === 'completed' && newStatus !== 'completed') {
                    toast.error(t('error_status_dependency_finished', { taskTitle: dep.dependentTask.title }));
                    isCompatible = false;
                }
            }

            if (dep.dependencyType === 'Start-to-Finish') {
                // Dependent task "completed" durumundaysa ve ana task "to-do" yapılmak isteniyorsa
                if (dep.dependentTask.status === 'completed' && newStatus === 'to-do') {
                    toast.error(t('error_status_dependency_finished_in_progress', { taskTitle: dep.dependentTask.title }));
                    isCompatible = false;
                }
                // Dependent task "to-do" durumundaysa ve ana task "completed" yapılmak isteniyorsa
                if (dep.dependentTask.status === 'to-do' && newStatus === 'completed') {
                    toast.error(t('error_dependency_must_start_first', { taskTitle: dep.dependentTask.title }));
                    isCompatible = false;
                }
            }
        });


        return isCompatible;
    };




    const fetchAvailableItems = async (itemType, itemId) => {
        try {
            if (itemType === 'task') {
                // Task bağımlılıkları için diğer task'ları al
                const taskResponse = await api.get(`/api/tasks/project/${task.project_id}?mode=dependency-select`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                });
    
                const tasksArray = Array.isArray(taskResponse.data.tasks) ? taskResponse.data.tasks : [];
                setAvailableItems(tasksArray.filter(t => t.id !== itemId)); // Şu anki task'ı hariç tut
            } else {
                // Subtask bağımlılıkları için diğer subtask'ları al
                const subtaskResponse = await api.get(`/api/subtasks/${subtask.task_id}/subtasks?mode=dependency-select`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                });
    
                const subtasksArray = Array.isArray(subtaskResponse.data.subtasks) ? subtaskResponse.data.subtasks : [];
                setAvailableItems(subtasksArray.filter(s => s.id !== itemId)); // Şu anki subtask'ı hariç tut
            }
        } catch (error) {
        }
    };
    



    const handleAddDependency = async () => {
        try {
            // Görev veya alt görev ID'sini ve türünü dinamik olarak belirle
            const itemType = task ? 'task' : 'subtask';
            const itemId = task ? task.id : subtask.id;

            // Dinamik olarak dependentId'yi oluştur
            const dependentIdKey = itemType === 'task' ? 'dependentTaskId' : 'dependentSubtaskId';
            const mainIdKey = itemType === 'task' ? 'taskId' : 'subtaskId';

            // Post isteği için dinamik bir body yapısı oluştur
            const requestBody = {
                [mainIdKey]: itemId,
                [dependentIdKey]: selectedTask, // Bağımlı görev veya alt görev
                dependencyType: dependencyType,
            };

            // Dinamik endpoint oluştur ve isteği gönder
            await api.post(`/api/${itemType}dependencies`, requestBody, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });

            // Bağımlılıkları güncelle
            await fetchDependencies(itemType, itemId);
        } catch (error) {
            // Hata mesajını kontrol edip kullanıcıya göster
            if (error.response && error.response.status === 400 && error.response.data.error) {
                //alert(`Error: ${error.response.data.error}`);
                toast.error(error.response.data.error)
            } else {
            }
        }
    };

    const handleDeleteDependency = async (dependencyId) => {
        try {
            const itemType = task ? 'task' : 'subtask';
            await api.delete(`/api/${itemType}dependencies/${dependencyId}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });
            await fetchDependencies(task ? 'task' : 'subtask', task ? task.id : subtask.id);
        } catch (error) {
        }
    };


    const handleSaveDetails = async () => {
        try {
            console.log("🟢 handleSaveDetails başlatıldı...");
            
            const itemType = task ? 'task' : 'subtask';
            const itemId = task ? task.id : subtask.id;
    
            console.log(`📌 Güncellenen itemType: ${itemType}, itemId: ${itemId}`);
    
            const token = localStorage.getItem('token');
            const url = `/api/${itemType}s/${itemId}`;
    
            const updatedDetails = {
                ...details,
                ...(itemType === 'task' && { assigned_team_id: assignedTeam || null }),
                [itemType === 'task' ? 'assigned_user_id' : 'assigned_to']: assignedUser || null
            };
    
            console.log("📌 Güncellenecek detaylar:", updatedDetails);
    
            const newStartDate = new Date(updatedDetails.start_date);
            const newEndDate = new Date(updatedDetails.due_date);
    
            if (task) {
                if (
                    (details.earliest_subtask_start && newStartDate > new Date(details.earliest_subtask_start)) ||
                    (details.latest_subtask_end && newEndDate < new Date(details.latest_subtask_end))
                ) {
                    console.warn("⛔ Görev tarihleri, alt görev sınırlarını ihlal ediyor.");
                    toast.error(
                        t('error_task_dates_subtask_violation', {
                          earliestStart: details.earliest_subtask_start,
                          latestEnd: details.latest_subtask_end
                        }),
                        { position: 'top-right', autoClose: 5000 }
                      );
                    return;
                }
            }
    
            if (subtask) {
                console.log("📌 Ana görev sınırları kontrol ediliyor...");
                console.log("🟡 Parent Task Start:", details.parent_task_start);
                console.log("🟡 Parent Task End:", details.parent_task_end);
                console.log("🟡 New Start Date:", newStartDate);
                console.log("🟡 New End Date:", newEndDate);
    
                if (
                    (details.parent_task_start && newStartDate < new Date(details.parent_task_start)) ||
                    (details.parent_task_end && newEndDate > new Date(details.parent_task_end))
                ) {
                    console.warn("⛔ Alt görev tarihleri, ana görev sınırlarını ihlal ediyor.");
                    toast.error(
                        t('error_subtask_dates_parent_violation', {
                          parentStart: details.parent_task_start,
                          parentEnd: details.parent_task_end
                        }),
                        { position: 'top-right', autoClose: 5000 }
                      );
                    return;
                }
            }
    
            const newStatus = updatedDetails.status;
    
            if (!checkStatusCompatibility(newStatus)) {
                console.warn("⛔ Durum uyumsuzluğu nedeniyle işlem iptal edildi.");
                return;
            }
    
            console.log(`📌 ${itemType} güncelleniyor...`);
    
            const response = await api.patch(url, updatedDetails, {
                headers: { Authorization: `Bearer ${token}` },
            });
    
            console.log("📌 API Yanıtı:", response);
    
            if (response.status === 200) {
                console.log("✅ Güncelleme başarılı!");
                setDetails(response.data);
                setIsEditMode(false);
    
                // 🔄 Eğer `refreshData` fonksiyonu varsa çağır, yoksa hata verme
            if (typeof refreshData === 'function') {
                if (itemType == 'subtask') {
                    console.log(`🔄 Alt görev için refreshData çağırılıyor: subtask_id = ${subtask.id}`);
                    refreshData(subtask.task_id, subtask.id);
                } else if (itemType == 'task') {
                    console.log(`🔄 Görev için refreshData çağırılıyor: task_id = ${task.id}`);
                    refreshData(task.id);
                }
            } else {
                console.log("⚠️ refreshData tanımlı değil, çağrılmadı.");
            }
    
                toast.success(t('success_item_updated', { itemType: itemType === 'task' ? 'Task' : 'Subtask' }));
            } else {
                console.warn("❌ Beklenmeyen API yanıtı:", response);
            }
    
        } catch (error) {
            console.error("❌ Hata oluştu:", error);
    
            const itemType = task ? 'task' : 'subtask';
            let errorMessage = t('error_unexpected');
    
            if (error.response) {
                console.error("❌ API Hata Yanıtı:", error.response);
                
                if (error.response.data && error.response.data.error) {
                    errorMessage = error.response.data.error;
                } else if (error.response.status === 400) {
                    errorMessage = t('error_bad_request');
                } else if (error.response.status === 401) {
                    errorMessage = t('error_unauthorized');
                } else if (error.response.status === 404) {
                    errorMessage = t('error_item_not_found', { itemType: itemType === 'task' ? 'Task' : 'Subtask' });
                } else if (error.response.status === 500) {
                    errorMessage = t('error_server');
                }
            }
    
            console.warn("⛔ Toast hata mesajı gösteriliyor:", errorMessage);
            toast.error(t('error_update_failed', { itemType: itemType, errorMessage }));
        }
    };
    



    const handleTabChange = (event, newValue) => {
        //console.log(newValue);
        setCurrentTab(newValue);
    };
    const handleSelectChange = (event) => {
        setCurrentTab(event.target.value);
    };


    const checkPermissions = () => {
        if (!details || !currentUser) {
            // Eğer details veya currentUser henüz yüklenmediyse varsayılan false döner
            setIsAuthorized(false);
            setHasFullAccess(false);
            //console.log('Details or currentUser is missing. isAuthorized: false, hasFullAccess: false');
            return;
        }

        const assignedUserId = task ? details.assigned_user_id : details.assigned_to;  // Task için `assigned_user_id`, subtask için `assigned_to`
        const assignedTeamId = task ? details.assigned_team_id : null;  // Eğer alt görevse takım id null
        const assignedTeams = currentUser?.teams ? currentUser.teams.map(team => team.id) : [];  // currentUser.teams boş ise boş dizi döner
        const isTeamManager = currentUser?.teams?.some(team => team.id === assignedTeamId && team.managerId === user.id);

        

        // Kullanıcının atanmış kullanıcı olup olmadığını kontrol et
        const isAssignedToUser = assignedUserId === user.id;

        // Eğer görev hem bir kullanıcıya hem de bir takıma atanmışsa ve atanmış kullanıcı currentUser değilse ve team manager değilse false döner
        if (assignedUserId && assignedTeamId && !isAssignedToUser && !isTeamManager && !currentUser.roleId === 1) {
            setIsAuthorized(false);
            setHasFullAccess(false);
            //console.log('Task assigned to both a user and a team, but currentUser is neither the assigned user nor the team manager. isAuthorized: false, hasFullAccess: false');
            return;
        }

        // Takım kontrolü sadece `assignedTeamId` null değilse yapılır
        const isAssignedToTeam = assignedTeamId ? assignedTeams.includes(assignedTeamId) : false;

        // Eğer kullanıcı proje yöneticisi değilse ve ne atanmış kullanıcı ne de atanmış takımdaysa false döner
        const isAuthorizedValue = currentUser.roleId === 1 || isAssignedToUser || isAssignedToTeam || isTeamManager;

        // Görev, takım yöneticisi tarafından atanmış mı?
        const isAssignedByTeamManager = details.created_by === user.id && isTeamManager;

        // Eğer takım yöneticisi atanmışsa ve kendisi atanmış kullanıcı ise tam yetki veririz
        const hasFullAccessValue = (isAuthorizedValue && isAssignedByTeamManager) || currentUser.roleId === 1;

        

        // State'leri set et
        setIsAuthorized(isAuthorizedValue);
        setHasFullAccess(hasFullAccessValue);
    };
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Ekran genişliği küçükse true döner

    const formatDate = (date) =>
        new Date(date).toLocaleDateString(navigator.language);
      


    // useEffect içinde checkPermissions'ı çağırarak state'leri güncelleyin
    useEffect(() => {
        checkPermissions();
    }, [details, currentUser, task]);

    if (!task && !subtask) return null;

    return (
        <Modal open={open} onClose={() => {
            setIsEditMode(false); // Modal kapatıldığında edit modunu kapat
            onClose(); // Diğer kapatma işlemlerini yap
        }}>
            <div
                style={{
                    padding: 20,
                    backgroundColor: 'white',
                    width: '80vw', // Genişlik ekranın %80'i
                    height: '80vh', // Yükseklik ekranın %80'i
                    margin: '5% auto', // Ortalamak için margin
                    position: 'relative', // Konum ayarlaması
                    display: 'flex',
                    flexDirection: 'column',
                    overflowY: 'auto',
                    borderRadius: 12,
        boxShadow: 9,
                }}
            >
                <ToastContainer />
                <Typography className='modal-header'>
    {task
        ? t('modal_task', { taskTitle: task.title })
        : subtask
            ? t('modal_subtask', { subtaskTitle: subtask.title })
            : t('modal_task_details')}
</Typography>
<div className="modal-divider"></div>
{isMobile ? (
    <Select
        value={currentTab}
        onChange={handleSelectChange}
        variant="outlined"
        fullWidth
        style={{ marginBottom: '16px' }}
    >
        <MenuItem value={0}>{t('modal_task_details')}</MenuItem>
        <MenuItem value={1}>{t('modal_comments')}</MenuItem>
        <MenuItem value={2}>{t('modal_files')}</MenuItem>
        <MenuItem value={3}>{t('modal_dependencies')}</MenuItem>
    </Select>
) : (
    <Tabs
        value={currentTab}
        onChange={handleTabChange}
        variant="fullWidth"
        textColor="primary"
        indicatorColor="primary"
    >
        <Tab label={t('modal_task_details')} />
        <Tab label={t('modal_comments')} />
        <Tab label={t('modal_files')} />
        <Tab label={t('modal_dependencies')} />
    </Tabs>
)}
               {/* Task Details Tab */}
{currentTab === 0 && details ? (
    <div>
        {/* Normal Mod: Statik Bilgiler */}
        {!isEditMode ? (
            <Box sx={{ padding: 2, backgroundColor: 'white', borderRadius: 2, boxShadow: 1, mb: 2 }}>
                <Typography variant="h6" color="primary" gutterBottom>
                    {t('task_information')}
                </Typography>
                <Box
  sx={{
    mb: 2,
    direction: isArabic ? 'rtl' : 'ltr',
    textAlign: isArabic ? 'right' : 'left',
  }}
>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                        <strong>{t('title')}:</strong> {details.title}
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                        <strong>{t('description')}:</strong> {details.description}
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                    <strong>{t('start_date')}:</strong> {formatDate(details.start_date)}
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                    <strong>{t('end_date')}:</strong> {formatDate(details.due_date)}

                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                        <strong>{t('priority')}:</strong> {t(`priority_${details.priority}`)}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            backgroundColor:
                                details.status === 'to-do'
                                    ? '#f0f0f0' // Light Gray for "To Do"
                                    : details.status === 'in-progress'
                                        ? '#ffecb3' // Light Yellow for "In Progress"
                                        : details.status === 'completed'
                                            ? '#c8e6c9' // Light Green for "Completed"
                                            : '#ffffff', // Default White
                            padding: '8px',
                            borderRadius: '4px',
                            display: 'inline-block',
                            mb: 1,
                        }}
                    >
                        <strong>{t('status')}:</strong> {t(`webstatus_${details.status}`)}
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                        <strong>{t('assigned_team')}:</strong> {teams.find((team) => team.id === assignedTeam)?.name || t('not_assigned')}
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                        <strong>{t('assigned_user')}:</strong> {members.find((member) => member.id === assignedUser)?.name || t('not_assigned')}
                    </Typography>
                </Box>

                {(isAuthorized || hasFullAccess) && (
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => setIsEditMode(true)}
                        sx={{ mt: 2 }}
                    >
                        {t('edit')}
                    </Button>
                )}
            </Box>
        ) : (
            <>
                {/* Edit Modu: Düzenlenebilir Form Alanları */}
                <TextField
                    label={t('title')}
                    fullWidth
                    margin="normal"
                    value={details.title}
                    onChange={(e) => setDetails({ ...details, title: e.target.value })}
                    disabled={!hasFullAccess}
                    inputProps={{
                        dir: isArabic ? 'rtl' : 'ltr',
                      }}
                />
                <TextField
                    label={t('description')}
                    fullWidth
                    margin="normal"
                    multiline
                    minRows={4}
                    maxRows={10}
                    value={details.description}
                    onChange={(e) => setDetails({ ...details, description: e.target.value })}
                    disabled={!hasFullAccess}
                    inputProps={{
                        dir: isArabic ? 'rtl' : 'ltr',
                      }}
                />

                {/* Start Date ve End Date aynı satırda */}
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <TextField
                            label={t('start_date')}
                            type="date"
                            value={details.start_date}
                            onChange={(e) => setDetails({ ...details, start_date: e.target.value })}
                            disabled={!hasFullAccess}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            label={t('end_date')}
                            type="date"
                            value={details.due_date}
                            onChange={(e) => setDetails({ ...details, due_date: e.target.value })}
                            disabled={!hasFullAccess}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </Grid>

                {/* Assign to Team and User Seçimleri */}
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        {(currentUserRoleId === 1 || currentUserRoleId === 2) && (
                            <FormControl fullWidth margin="normal" variant="outlined">
                                <InputLabel>{t('assign_team')}</InputLabel>
                                <Select
                                    value={assignedTeam}
                                    onChange={(e) => setAssignedTeam(e.target.value)}
                                    disabled={!!subtask || !hasFullAccess}
                                    label={t('assign_team')}
                                >
                                    <MenuItem value="">{t('not_assigned')}</MenuItem>
                                    {teams.map((team) => (
                                        <MenuItem key={team.id} value={team.id}>
                                            {team.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl fullWidth margin="normal" variant="outlined">
                            <InputLabel>{t('assign_user')}</InputLabel>
                            <Select
                                value={assignedUser}
                                onChange={(e) => setAssignedUser(e.target.value)}
                                disabled={!hasFullAccess}
                                label={t('assign_user')}
                            >
                                <MenuItem value="">{t('select_user')}</MenuItem>
                                {filteredMembers.map((member) => (
                                    <MenuItem key={member.id} value={member.id}>
                                        {member.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>

                {warningMessage && (
                    <Typography color="error" style={{ marginTop: '10px' }}>
                        {warningMessage}
                    </Typography>
                )}

                {/* Priority ve Status aynı satırda */}
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <FormControl fullWidth margin="normal" variant="outlined">
                            <InputLabel>{t('priority')}</InputLabel>
                            <Select
                                value={details.priority}
                                onChange={(e) => setDetails({ ...details, priority: e.target.value })}
                                disabled={!hasFullAccess}
                                variant="outlined"
                                label={t('priority')}
                            >
                                <MenuItem value="low">{t('priority_low')}</MenuItem>
                                <MenuItem value="medium">{t('priority_medium')}</MenuItem>
                                <MenuItem value="high">{t('priority_high')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl fullWidth margin="normal" variant="outlined">
                            <InputLabel>{t('status')}</InputLabel>
                            <Select
                                value={details.status}
                                onChange={(e) => setDetails({ ...details, status: e.target.value })}
                                disabled={!isAuthorized && !hasFullAccess}
                                variant="outlined"
                                label={t('status')}
                            >
                                <MenuItem value="to-do">{t('status_to_do')}</MenuItem>
                                <MenuItem value="in-progress">{t('status_in_progress')}</MenuItem>
                                <MenuItem value="completed">{t('status_completed')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>

                <Button variant="outlined" color="primary" onClick={handleSaveDetails}>{t('save')}</Button>
                <Button variant="outlined" color="secondary" onClick={() => setIsEditMode(false)}>{t('cancel')}</Button>
            </>
        )}
    </div>
) : null}



{currentTab === 1 && details ? (
    <>
        <div style={{ maxHeight: '50vh', overflowY: 'auto', flexGrow: 1 }}>
            <List>
                {comments.map((comment) => (
                    <div key={comment.id} style={{ marginBottom: '5px' }}>
                        <ListItem
                            style={{
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                paddingLeft: '20px',
                                backgroundColor: '#f0f0f0',
                            }}
                        >
                            <ListItemText
                                primary={<span className="comment-text">{comment.content}</span>}
                                secondary={
                                    <span className="comment-by-text">
                                        {t("comment_by")}: <span className="comment-user-text">{comment.user.name}</span>
                                    </span>
                                }
                            />
                            {(isAuthorized || hasFullAccess) && (
                                <Button size="small" onClick={() => setReplyToCommentId(comment.id)} style={{}}>
                                    {t("reply")}
                                </Button>
                            )}

                            {comment.id === replyToCommentId && (
                                <div style={{ marginTop: '10px', display: 'flex', width: '50%' }}>
                                    <TextField
                                        label={t("reply")}
                                        value={newReply}
                                        onChange={(e) => setNewReply(e.target.value)}
                                        multiline
                                        rows={2}
                                        style={{ width: '100%' }}
                                    />
                                    <Button
                                        onClick={() => {
                                            handleAddReply(comment.id);
                                            setNewReply('');
                                            setReplyToCommentId(null);
                                        }}
                                        variant="contained"
                                        color="primary"
                                        className="action-button"
                                    >
                                        {t("send")}
                                    </Button>
                                </div>
                            )}
                        </ListItem>

                        {comment.replies && comment.replies.length > 0 && (
                            <List style={{ paddingLeft: '20px', marginTop: '2px' }}>
                                {comment.replies.map((reply) => (
                                    <ListItem
                                        key={reply.id}
                                        style={{
                                            border: '1px solid #ddd',
                                            borderRadius: '8px',
                                            backgroundColor: '#fafafa',
                                            paddingLeft: '10px',
                                            marginBottom: '5px',
                                            marginLeft: '30px',
                                            width: 'calc(100% - 50px)',
                                        }}
                                    >
                                        <ListItemText
                                            primary={<span className="comment-text">{reply.content}</span>}
                                            secondary={
                                                <span className="comment-by-text">
                                                    {t("replied_by")}: <span className="comment-user-text">{reply.user.name}</span>
                                                </span>
                                            }
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        )}
                    </div>
                ))}
            </List>
        </div>

        <Pagination
            totalItems={totalComments}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={(page) => {
                setCurrentPage(page);
            }}
        />

        {(isAuthorized || hasFullAccess) && (
            <div style={{ marginTop: '10px' }}>
                <TextField
                    label={t("new_comment")}
                    value={newComment}
                    onChange={(e) => setNewComment(e.target.value)}
                    fullWidth
                    multiline
                    rows={3}
                    style={{ marginBottom: '10px' }}
                />
                <Button onClick={handleAddComment} className='action-button'>
                    {t("add_comment")}
                </Button>
            </div>
        )}
    </>
) : null}

{currentTab === 2 && (
    <>
        <div style={{ maxHeight: '50vh', overflowY: 'auto', flexGrow: 1 }}>
            <Typography variant="h6" style={{ margin: '20px 0' }}>
                {t("file_links")}
            </Typography>
            <List>
                {fileLinks.map((file) => {
                    const shortLink = file.fileLink.length > 30 ? `${file.fileLink.substring(0, 30)}...` : file.fileLink;
                    return (
                        <ListItem key={file.id} style={{ borderBottom: '1px solid #e0e0e0', padding: '10px 0' }}>
                            <ListItemText
                                primary={<Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>{file.description}</Typography>}
                                secondary={`${t("uploaded_by")}: ${file.user.name}`}
                            />
                            <ListItemText
                                primary={
                                    <Button
                                        variant="text"
                                        color="primary"
                                        onClick={() => window.open(file.fileLink, '_blank')}
                                        style={{ textTransform: 'none' }}
                                    >
                                        {shortLink}
                                    </Button>
                                }
                            />
                        </ListItem>
                    );
                })}
            </List>
        </div>

        {/* File Upload Section */}
        {(isAuthorized || hasFullAccess) && (
            <div style={{ marginTop: '20px', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }}>
                <Typography variant="h6" gutterBottom>{t("add_new_file_link")}</Typography>
                <TextField
                    label={t("file_description")}
                    value={newFileDescription}
                    onChange={(e) => setNewFileDescription(e.target.value)}
                    fullWidth
                    margin="dense"
                />
                <TextField
                    label={t("file_link_url")}
                    value={newFileLink}
                    onChange={(e) => setNewFileLink(e.target.value)}
                    fullWidth
                    margin="dense"
                />
                <Button
                    onClick={handleAddFileLink}
                    variant="contained"
                    color="primary"
                    style={{ marginTop: '10px' }}
                    disabled={!newFileDescription || !newFileLink}
                >
                    {t("add_file_link")}
                </Button>
            </div>
        )}
    </>
)}

{currentTab === 3 && (
    <>
        <Box>
            {/* Bağımlılık türlerini açıklayan bilgi kartları */}
            <Box style={{ marginBottom: '20px' }}>
                <Typography variant="h6" color="textSecondary">{t("choose_dependency_type")}</Typography>
                <Typography variant="body2" color="textSecondary" mt={1}>
                    {t("dependency_details", { taskTitle: task ? `Task ${task.title}` : `Subtask ${subtask?.title || ''}` })}
                </Typography>
                <Box display="flex" flexDirection="row" justifyContent="space-around" mt={2}>
                    {[
                        { type: 'Finish-to-Start', color: '#FF7F50', description: t("fs_description") },
                        { type: 'Start-to-Start', color: '#87CEEB', description: t("ss_description") },
                        { type: 'Finish-to-Finish', color: '#98FB98', description: t("ff_description") },
                        { type: 'Start-to-Finish', color: '#FFD700', description: t("sf_description") },
                    ].map((dep, index) => (
                        <Box
                            key={index}
                            style={{
                                backgroundColor: dep.color,
                                padding: '10px',
                                borderRadius: '8px',
                                width: '22%',
                                textAlign: 'center',
                            }}
                        >
                            <Typography variant="body1" fontWeight="bold">{dep.type}</Typography>
                            <Typography variant="body2">{dep.description}</Typography>
                        </Box>
                    ))}
                </Box>
            </Box>

            {/* Bağımlılık listesi */}
            <List>
                {dependencies.map(dep => (
                    <ListItem key={dep.id}>
                        <ListItemText
                            primary={t("dependency_task", { dependentTask: dep.dependentTask.title, type: dep.dependencyType })}
                        />
                        <IconButton onClick={() => handleDeleteDependency(dep.id)}>
                            <DeleteIcon />
                        </IconButton>
                    </ListItem>
                ))}
            </List>

            <List>
                {dependentOn.map(dep => (
                    <ListItem key={dep.id}>
                        <ListItemText
                            primary={t("dependency_main_task", { mainTask: dep.mainTask.title, type: dep.dependencyType })}
                        />
                    </ListItem>
                ))}
            </List>

            {/* Yeni bağımlılık ekleme formu */}
            {(hasFullAccess) && currentUser.roleId !== 3 && (
                <Box mt={3}>
                    <FormControl fullWidth style={{ marginTop: '10px' }} variant="outlined">
                        <InputLabel>{t("select_task")}</InputLabel>
                        <Select value={selectedTask} onChange={(e) => setSelectedTask(e.target.value)} variant="outlined"
                            label={t("select_task")}>
                            {availableItems.map(item => (
                                <MenuItem key={item.id} value={item.id}>{item.title}</MenuItem>
                            ))}
                        </Select>
                        <Typography variant="body2" color="textSecondary" mt={1}>
                            {t("select_task_description")}
                        </Typography>
                    </FormControl>

                    <FormControl fullWidth style={{ marginTop: '20px' }} variant="outlined">
                        <InputLabel>{t("select_dependency_type")}</InputLabel>
                        <Select value={dependencyType} onChange={(e) => setDependencyType(e.target.value)} variant="outlined"
                            label={t("select_dependency_type")}>
                            <MenuItem value="Finish-to-Start">
                                <span style={{ color: '#FF7F50', fontWeight: 'bold' }}>● {t("finish_to_start")}</span>
                            </MenuItem>
                            <MenuItem value="Start-to-Start">
                                <span style={{ color: '#87CEEB', fontWeight: 'bold' }}>● {t("start_to_start")}</span>
                            </MenuItem>
                            <MenuItem value="Finish-to-Finish">
                                <span style={{ color: '#98FB98', fontWeight: 'bold' }}>● {t("finish_to_finish")}</span>
                            </MenuItem>
                            <MenuItem value="Start-to-Finish">
                                <span style={{ color: '#FFD700', fontWeight: 'bold' }}>● {t("start_to_finish")}</span>
                            </MenuItem>
                        </Select>
                        <Typography variant="body2" color="textSecondary" mt={1}>
                            {t("select_dependency_type_description")}
                        </Typography>
                    </FormControl>
                    <Button onClick={handleAddDependency} variant="contained" color="primary" style={{ marginTop: '20px' }}>
                        {t("add_dependency")}
                    </Button>
                </Box>
            )}
        </Box>
    </>
)}

            </div>
        </Modal>

    );
};

export default DetailsForm;
